<template>
    <aside id="menu_container">
        <EMapMenu v-show="selected_main_menu==='emap'" 
            @transfer-information="(information) => $emit('transfer-information', information)"
        />
        <AtlasMenu v-if="atlas_loaded" 
            v-show="selected_main_menu === 'atlas'"
            :atlas_menu_data="atlas_menu_data"
        />
        <MonitorMenu v-if="monitor_loaded" 
            v-show="selected_main_menu === 'monitor'"
        />

        <Account v-show="selected_main_menu === 'account'" />

        <LanguageSetting v-show="selected_main_menu === 'language_setting'" />

        <About v-show="selected_main_menu === 'about'" />
    </aside>
</template>

<script>
    import { mapState } from 'vuex'
    import EMapMenu from '@/components/emap/menu/all_emap_menu.vue'

    export default {
        name: 'MainMenu',

        components: {
            EMapMenu,
            AtlasMenu: () => import('@/components/atlas/menu/atlas_menu.vue'),
            MonitorMenu: () => import('@/components/monitor/menu/monitor_menu.vue'),
            Account: () => import('@/components/menu_common/account.vue'),
            LanguageSetting: () => import('@/components/menu_common/language_setting.vue'),
            About: () => import('@/components/menu_common/about.vue'),
        },
        
        props: {
            atlas_menu_data: {
                type: Object,
                required: true
            },
            
            selected_main_menu: {
                type: String,
                required: true,
            }
        },

        computed: {
            ...mapState([
                'client_name',
            ]),

            ...mapState({
                is_atlas: state => state.atlas.is_atlas,
                atlas_loaded: state => state.atlas.atlas_loaded,
                is_monitor: state => state.monitor.is_monitor,
                monitor_loaded: state => state.monitor.monitor_loaded,
            }),
        },
    }
</script>    